import { Injectable } from '@angular/core';

import { activity_status, TaskLog } from '../models';
import { AppState } from '../app-state';

import { RxDocument } from 'rxdb';
import { TestbedRxdbCouchCollectionService } from './testbed-rxdb/testbed-rxdb-couch-collection.service';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';
import taskLogSchema from '../schema/task-log-schema';

export type PointTestLogDoc = RxDocument<TaskLog,{}>

@Injectable({ providedIn: 'root' })
export class PointTestLogService extends TestbedRxdbCouchCollectionService<TaskLog,PointTestLogDoc> {

    constructor( appState : AppState, authService: AuthenticationService, rxdbState: TestbedRxdbState ) {
        super('point_test_log', taskLogSchema, appState, rxdbState, authService)
        this.syncConfig = {
            push: true,
            pull: true,
            intervalMs: appState.settings.get('rxdb.collections.point_test_log.intervalMs',0),
            retry: true
        }
    }    


    create( taskLog : TaskLog) {
        console.log("create() " + JSON.stringify(taskLog));
        taskLog._id = this.generateId()
        return this.rxCollection.insert(this.rxCollection.newDocument(taskLog))
    }


    textForStatusId = (statusId: number) => {
        switch (statusId) {
            case activity_status.Id.NOT_STARTED: return '[Not Started]'
            case activity_status.Id.IN_PROGRESS: return '[Start]'
            case activity_status.Id.COMPLETE: return '[End]'
            default: return `[${activity_status.Names.byId(statusId)}]`
        }
    }


    async logComment( pathTestPointId: string, text: string ) {
        console.log(`logComment(pathTestPointId:${pathTestPointId},text:${text?.substr(0,10)}...)`)
        const taskLog = { 
          text: text, 
          taskId: pathTestPointId, // test points used to be tasks but now points in a pathTest
          timestamp: this.nowTimeStamp(), 
          userId: this.appState.getUser()._id
        }
    
        try {
          const taskLogDoc = await this.create( taskLog )
          //this.publishSuccess('Log entry added',this)
          return true
        } catch ( error ) {
          console.error((`logComment() failed for pathTestPointId ${pathTestPointId}. ${error?.message}`))
          throw error
        }
    }
}